// extracted by mini-css-extract-plugin
export default {"module":"slider_module__W9d2o","wrapper":"slider_wrapper__QTiyZ"};